module.exports = __webpack_public_path__ + "static/media/company2.307ed353.png";